import { Link, useLocation } from "react-router-dom";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import "./CSS/NavBot.css";

function NavBot() {
  var numberPage;
  var titlePage;
  var directUp;
  var directDown;
  const { pathname } = useLocation();

  switch (pathname) {
    case "/":
      numberPage = "01";
      titlePage = "Home";
      break;
    case "/about":
      numberPage = "02";
      titlePage = "About";
      break;
    case "/services":
      numberPage = "03";
      titlePage = "Services";
      break;
    case "/projects":
      numberPage = "04";
      titlePage = "Projects";
      break;
    case "/skills":
      numberPage = "03";
      titlePage = "Skills";
      break;
    default:
  }

  // Direct Up
  switch (pathname) {
    case "/":
      directUp = "/projects";
      break;
    case "/about":
      directUp = "/";
      break;
    case "/services":
      directUp = "/about";
      break;
    case "/projects":
      directUp = "/services";
      break;
    case "/skills":
      directUp = "/about";
      break;
    default:
  }

  // Direct Down
  switch (pathname) {
    case "/":
      directDown = "/about";
      break;
    case "/about":
      directDown = "/services";
      break;
    case "/services":
      directDown = "/projects";
      break;
    case "/projects":
      directDown = "/";
      break;
    case "/skills":
      directDown = "/projects";
      break;
    default:
  }

  return (
    <>
      <footer className="navbot px-4">
        <div className="navbot-left d-flex">
          <p className="navbot-title">{titlePage}</p>
          <p className="navbot-number">
            {numberPage} <span className="disabled-color">/ 04</span>
          </p>
        </div>
        <div className="navbot-right d-flex">
          <Link to={directUp} className="d-flex align-items-center arrow" aria-label={`Previous page: ${directUp}`}>
            <AiOutlineArrowLeft />
          </Link>
          <Link
            to={directDown}
            className="d-flex align-items-center ps-4 arrow"
            aria-label={`Next page: ${directDown}`}
          >
            <AiOutlineArrowRight />
          </Link>
        </div>
      </footer>
    </>
  );
}

export default NavBot;
